export const CONTENT = {
  "en": {
    "seo": {
      "title": "DaddyAnna247 | Online Cricket ID & Live Casino ID in India",
      "description": "Get your instant online cricket betting ID and live casino ID with DaddyAnna247. Fast UPI deposits, withdrawals in minutes and 24/7 support on WhatsApp, Telegram and Signal."
    },
    "nav": [
      "Exchange",
      "Games",
      "How It Works",
      "Reviews",
      "Payments",
      "FAQ"
    ],
    "ticker": [
      "New ID issued in Mumbai — under 2 minutes",
      "₹48,500 withdrawal settled to UPI — Pune",
      "IPL markets live with premium liquidity",
      "₹1,20,000 payout processed — Hyderabad",
      "Live Teen Patti tables open 24/7",
      "New ID issued in Delhi — under 2 minutes"
    ],
    "header": {
      "login": "Login",
      "join": "Join Now"
    },
    "hero": {
      "eyebrow": "India's Premium Betting ID Desk",
      "h1a": "Play Like",
      "h1gold": "Royalty.",
      "h1b": "Win Around The Clock.",
      "sub": "Get your exclusive online cricket and casino ID in minutes. Instant deposits, swift withdrawals and a personal manager — always one message away.",
      "cta": "Get Your ID",
      "how": "How It Works",
      "connect": "Connect via",
      "services": [
        "Cricket ID",
        "Sports Exchange ID",
        "Live Casino ID",
        "Teen Patti",
        "Andar Bahar",
        "Aviator",
        "Horse Racing",
        "Kabaddi",
        "Virtual Sports"
      ],
      "image": ""
    },
    "exchange": {
      "eyebrow": "Live Exchange",
      "title": "Markets That Never Sleep",
      "sub": "A preview of the rates waiting for you. Tap any price to claim your ID and place your play.",
      "tabs": {
        "cricket": "Cricket",
        "football": "Football",
        "tennis": "Tennis"
      },
      "live": "LIVE",
      "note": "Indicative rates for illustration only."
    },
    "games": {
      "eyebrow": "Sports & Casino",
      "title": "One ID. Every Game.",
      "sub": "From the first ball of the IPL to the last card at the Teen Patti table — it's all inside a single account.",
      "play": "Play Now",
      "items": [
        {
          "title": "Cricket Exchange",
          "desc": "Back & lay every ball — IPL, internationals, T20 leagues and domestic cups with deep markets.",
          "image": ""
        },
        {
          "title": "Live Casino",
          "desc": "Teen Patti, Andar Bahar, Roulette and Baccarat hosted by real dealers.",
          "image": ""
        },
        {
          "title": "Football",
          "desc": "Top leagues worldwide with match odds, goals and in-play markets.",
          "image": ""
        },
        {
          "title": "Tennis",
          "desc": "Grand Slams to ATP & WTA tours with point-by-point action.",
          "image": ""
        },
        {
          "title": "Aviator & Crash",
          "desc": "Fast-paced multiplier games — cash out before the plane flies away.",
          "image": ""
        }
      ]
    },
    "how": {
      "eyebrow": "Get Started",
      "title": "Your ID In Three Moves",
      "steps": [
        {
          "title": "Message Us",
          "desc": "Reach our desk on WhatsApp, Telegram or Signal. A dedicated manager replies within moments.",
          "icon": "MessageCircle"
        },
        {
          "title": "Make Your First Deposit",
          "desc": "Top up a small starting amount through UPI, PhonePe, GPay, Paytm or bank transfer.",
          "icon": "Wallet"
        },
        {
          "title": "Receive Your ID",
          "desc": "Your private login and password arrive instantly. Sign in and start playing right away.",
          "icon": "KeyRound"
        }
      ],
      "stats": [
        {
          "value": "5 Lakh+",
          "label": "Happy Players"
        },
        {
          "value": "2 Min",
          "label": "Average ID Delivery"
        },
        {
          "value": "24/7",
          "label": "Personal Support"
        },
        {
          "value": "100%",
          "label": "Privacy Protected"
        }
      ]
    },
    "testi": {
      "eyebrow": "Player Stories",
      "title": "Straight From The Chat",
      "sub": "Real conversations, real payouts. Here's what players across India tell our managers every day.",
      "desk": "DaddyAnna247 Desk",
      "online": "online",
      "typing": "typing…",
      "items": [
        {
          "name": "Rahul S.",
          "city": "Mumbai",
          "msg": "Got my ID in literally 2 minutes. Withdrawal of ₹25,000 hit my UPI before the match even ended!",
          "reply": "Thank you Rahul! Enjoy the rest of the season with us."
        },
        {
          "name": "Priya K.",
          "city": "Bengaluru",
          "msg": "Love the live Teen Patti tables. Support replied at 3 AM when I needed help — unbelievable service.",
          "reply": "We're always awake for you, Priya. Happy playing!"
        },
        {
          "name": "Arjun M.",
          "city": "Delhi",
          "msg": "Best cricket rates I've found. One ID for both sports and casino makes life so easy.",
          "reply": "That's exactly why we built it, Arjun. Good luck tonight!"
        },
        {
          "name": "Vikram R.",
          "city": "Hyderabad",
          "msg": "Was nervous at first but every payout has been smooth. Highly recommend to friends.",
          "reply": "Your trust means everything, Vikram. Welcome to the family!"
        }
      ]
    },
    "pay": {
      "eyebrow": "Deposits & Payouts",
      "title": "Money Moves At Your Speed",
      "sub": "Fund your wallet and cash out using the methods you already trust. Zero hidden charges, any hour.",
      "features": [
        {
          "title": "Lightning Withdrawals",
          "desc": "Request a payout any hour of the day and see it in your bank account within minutes.",
          "icon": "Zap"
        },
        {
          "title": "Trusted & Discreet",
          "desc": "Your details stay private. We never share player information with anyone.",
          "icon": "ShieldCheck"
        },
        {
          "title": "Human Support, Always",
          "desc": "Real account managers on chat around the clock — no bots, no waiting queues.",
          "icon": "Headphones"
        },
        {
          "title": "Sharpest Odds",
          "desc": "Competitive exchange rates and high liquidity across every major market.",
          "icon": "TrendingUp"
        },
        {
          "title": "No App Needed",
          "desc": "Play straight from your mobile browser. Light, fast and always up to date.",
          "icon": "Smartphone"
        },
        {
          "title": "Welcome Rewards",
          "desc": "Enjoy bonus offers on your first deposit and regular reload perks after that.",
          "icon": "Gift"
        }
      ]
    },
    "faq": {
      "eyebrow": "Questions",
      "title": "Good To Know",
      "sub": "Still curious? Our managers are online right now.",
      "chatOn": "Chat on",
      "items": [
        {
          "q": "How do I get my DaddyAnna247 ID?",
          "a": "Simply send us a message on WhatsApp, Telegram or Signal. Our team guides you through a quick deposit and shares your login credentials in about two minutes."
        },
        {
          "q": "What is the minimum deposit?",
          "a": "You can begin with a small amount. Our manager will confirm the current minimum when you get in touch — it is kept low so everyone can start comfortably."
        },
        {
          "q": "How fast are withdrawals?",
          "a": "Most withdrawals are completed within a few minutes, any time of day or night, straight to your bank or UPI account."
        },
        {
          "q": "Is my money and personal data safe?",
          "a": "Yes. Every transaction is handled by verified managers and your personal information is kept strictly confidential."
        },
        {
          "q": "Which games and sports can I play?",
          "a": "Cricket, football, tennis, horse racing, kabaddi, plus live casino favourites like Teen Patti, Andar Bahar, Roulette, Baccarat and Aviator."
        },
        {
          "q": "Can I use one ID for sports and casino?",
          "a": "Absolutely. A single DaddyAnna247 ID unlocks the full sports exchange and the complete casino lobby."
        }
      ]
    },
    "footer": {
      "ctaA": "Ready To",
      "ctaGold": "Take Your Seat?",
      "ctaSub": "Your premium ID is two minutes away.",
      "about": "A premium information desk for online sports exchange and casino IDs across India.",
      "rg": "This website is intended only for adults aged 18 and above. Betting involves financial risk and may be addictive — please play responsibly and only with money you can afford to lose. Set personal limits, take regular breaks and seek help if gaming stops being fun. It is your responsibility to check and comply with the laws applicable in your state or region before participating.",
      "rights": "All rights reserved.",
      "explore": "Explore",
      "info": "Information",
      "chat": "Chat With Us",
      "follow": "Follow Us",
      "disclaimer_title": "Restricted Territories",
      "disclaimer": "Our website and services are not available in some regions. If you live in any of the territories listed below, you are not permitted to access this site or use its services.",
      "territories": [
        "Afghanistan",
        "Algeria",
        "Australia",
        "Bosnia and Herzegovina",
        "Bulgaria",
        "Canada",
        "China (People's Republic Of)",
        "Cuba",
        "Cyprus",
        "Denmark",
        "Ethiopia",
        "France (and French Territories)",
        "Germany",
        "Gibraltar",
        "Iran (Islamic Republic Of)",
        "Iraq",
        "Ireland",
        "Italy",
        "Korea (Democratic People's Republic Of)",
        "Lao (People's Democratic Republic Of)",
        "Macau",
        "Malta",
        "Myanmar",
        "Netherlands",
        "New Zealand",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Romania",
        "Singapore",
        "Slovakia",
        "South Africa",
        "Spain",
        "Sudan",
        "Syrian Arab Republic",
        "Taiwan",
        "Turkey",
        "Uganda",
        "United Kingdom",
        "United States (and U.S. Territories)",
        "Yemen"
      ],
      "adults": "Adults only",
      "ssl": "SSL Secured",
      "help": "Problem Gambling Support",
      "gamble": "BeGambleAware.org",
      "show": "Show list",
      "hide": "Hide list"
    },
    "modal": {
      "a": "Claim Your",
      "gold": "ID",
      "desc": "Choose your favourite app — a manager will reply instantly.",
      "connect": "Connect"
    },
    "demo": "Get ID Demo",
    "exch": {
      "eyebrow": "Our Exchanges",
      "title": "Trusted Exchanges, One Desk",
      "sub": "Pick your favourite platform. Try it free with a demo ID, then get your real ID from our managers in minutes.",
      "user": "User ID",
      "pass": "Pass",
      "visit": "Visit Site",
      "getId": "Get Real ID",
      "copied": "Copied"
    },
    "proofs": {
      "eyebrow": "Withdrawal Proof",
      "title": "Real Payouts. Every Day.",
      "sub": "A glimpse of recent withdrawals sent to our players. Fast, transparent and straight to their bank or UPI.",
      "view": "View proof",
      "close": "Close"
    },
    "promo": {
      "eyebrow": "Welcome Bonus",
      "title": "Get Up To 10% Extra On Your First Deposit",
      "sub": "New players only — create your ID today and start with a bigger wallet.",
      "cta": "Claim Bonus",
      "terms": "T&C apply. Bonus details confirmed by your account manager.",
      "image": ""
    },
    "winner": {
      "won": "just won",
      "on": "on",
      "just": "Verified payout",
      "initials": [
        "A",
        "B",
        "C",
        "D",
        "G",
        "H",
        "K",
        "M",
        "N",
        "P",
        "R",
        "S",
        "T",
        "V"
      ],
      "names": [
        "Rahul",
        "Amit",
        "Priya",
        "Vikram",
        "Sanjay",
        "Neha",
        "Arjun",
        "Rohit",
        "Karan",
        "Pooja",
        "Deepak",
        "Suresh",
        "Anjali",
        "Manish",
        "Ravi"
      ],
      "cities": [
        "Mumbai",
        "Delhi",
        "Pune",
        "Jaipur",
        "Surat",
        "Lucknow",
        "Kolkata",
        "Chennai",
        "Hyderabad",
        "Indore",
        "Ahmedabad",
        "Bengaluru"
      ],
      "games": [
        "Cricket",
        "Teen Patti",
        "Aviator",
        "Andar Bahar",
        "Roulette",
        "Football"
      ]
    },
    "statsbar": {
      "items": [
        {
          "icon": "Users",
          "prefix": "",
          "value": "500000",
          "suffix": "+",
          "label": "Active Players"
        },
        {
          "icon": "Percent",
          "prefix": "",
          "value": "98",
          "suffix": "%",
          "label": "Payout Ratio"
        },
        {
          "icon": "Wallet",
          "prefix": "₹",
          "value": "2",
          "suffix": " Cr+",
          "label": "Paid Out Daily"
        },
        {
          "icon": "Trophy",
          "prefix": "",
          "value": "10000",
          "suffix": "+",
          "label": "Events Every Month"
        }
      ]
    },
    "bets": {
      "eyebrow": "Cricket Markets",
      "title": "Every Way To Play The Game",
      "sub": "From the toss to the trophy — choose the market that matches your read of the match.",
      "items": [
        {
          "icon": "Trophy",
          "title": "Match Winner",
          "desc": "Back the side you trust to win — the simplest and most popular cricket market.",
          "image": ""
        },
        {
          "icon": "Swords",
          "title": "Top Batsman",
          "desc": "Pick the player you expect to finish as the leading run-scorer for his team.",
          "image": ""
        },
        {
          "icon": "Target",
          "title": "Top Bowler",
          "desc": "Choose the bowler you think will take the most wickets in the innings.",
          "image": ""
        },
        {
          "icon": "Calculator",
          "title": "Total Runs",
          "desc": "Predict whether the innings or session total lands over or under the line.",
          "image": ""
        },
        {
          "icon": "CircleSlash",
          "title": "Method of Dismissal",
          "desc": "Caught, bowled, LBW, run out or stumped — call how the next wicket falls.",
          "image": ""
        },
        {
          "icon": "Medal",
          "title": "Man of the Match",
          "desc": "Spot the standout performer before the presentation ceremony does.",
          "image": ""
        },
        {
          "icon": "Layers",
          "title": "Series Winner",
          "desc": "Take a long view and back the team to lift the whole series.",
          "image": ""
        },
        {
          "icon": "Crown",
          "title": "Tournament Outright",
          "desc": "Pick the champion of IPL, World Cup and other leagues before a ball is bowled.",
          "image": ""
        }
      ]
    },
    "fixtures": {
      "eyebrow": "Upcoming Fixtures",
      "title": "Big Leagues On The Horizon",
      "sub": "Get your ID ready before the first ball. Markets open early with the best rates.",
      "cta": "Get ID & Play",
      "items": [
        {
          "league": "Indian Premier League",
          "teams": "10 franchises · 74 matches",
          "date": "March – May",
          "venue": "Across India",
          "image": ""
        },
        {
          "league": "Big Bash League",
          "teams": "8 teams · Summer T20",
          "date": "December – January",
          "venue": "Australia",
          "image": ""
        },
        {
          "league": "Pakistan Super League",
          "teams": "6 teams · Night T20s",
          "date": "February – March",
          "venue": "Pakistan",
          "image": ""
        },
        {
          "league": "ICC World Cup",
          "teams": "Top nations · Global title",
          "date": "Tournament season",
          "venue": "Worldwide",
          "image": ""
        }
      ]
    },
    "cities": {
      "eyebrow": "All-India Service",
      "title": "From Every Corner Of India",
      "sub": "Players in every state trust DaddyAnna247. Wherever you are, your manager is one message away.",
      "note": "…and 500+ more towns",
      "map_image": "https://static.prod-images.emergentagent.com/jobs/14353482-e7b8-451f-849a-61062bc4e228/images/2ead184eb0a5605b824deb7b183d22f2193917db4929276d0449a78f98882801.jpeg",
      "items": [
        "Mumbai",
        "Delhi",
        "Bengaluru",
        "Hyderabad",
        "Chennai",
        "Kolkata",
        "Pune",
        "Ahmedabad",
        "Jaipur",
        "Lucknow",
        "Surat",
        "Indore",
        "Chandigarh",
        "Patna",
        "Nagpur",
        "Kochi"
      ]
    },
    "rating": {
      "eyebrow": "Player Ratings",
      "title": "Rated Excellent By Players",
      "sub": "Honest feedback from thousands of verified DaddyAnna247 members.",
      "score": "4.8",
      "total": "Based on 12,480 reviews",
      "bars": [
        {
          "stars": "5",
          "pct": "82"
        },
        {
          "stars": "4",
          "pct": "13"
        },
        {
          "stars": "3",
          "pct": "3"
        },
        {
          "stars": "2",
          "pct": "1"
        },
        {
          "stars": "1",
          "pct": "1"
        }
      ],
      "badges": [
        {
          "icon": "BadgeCheck",
          "title": "Verified Payouts"
        },
        {
          "icon": "ShieldCheck",
          "title": "Secure & Private"
        },
        {
          "icon": "Clock",
          "title": "24/7 Support"
        },
        {
          "icon": "Star",
          "title": "Top Rated Desk"
        }
      ]
    },
    "guides": {
      "eyebrow": "Guides",
      "title": "Related Guides & Resources",
      "latest": "Latest from the blog",
      "columns": [
        {
          "heading": "Getting Started",
          "links": [
            {
              "label": "How to Play",
              "href": "/p/how-to-play"
            },
            {
              "label": "About DaddyAnna247",
              "href": "/p/about-us"
            },
            {
              "label": "Contact Us",
              "href": "/p/contact-us"
            }
          ]
        },
        {
          "heading": "Play Safe",
          "links": [
            {
              "label": "Responsible Gambling",
              "href": "/p/responsible-gambling"
            },
            {
              "label": "Terms of Service",
              "href": "/p/terms-of-service"
            },
            {
              "label": "Privacy Policy",
              "href": "/p/privacy-policy"
            }
          ]
        },
        {
          "heading": "Explore",
          "links": [
            {
              "label": "Our Exchanges",
              "href": "/#our-exchanges"
            },
            {
              "label": "Withdrawal Proof",
              "href": "/#withdraw-proof"
            },
            {
              "label": "All Articles",
              "href": "/blog"
            }
          ]
        }
      ]
    }
  },
  "hi": {
    "seo": {
      "title": "DaddyAnna247 | भारत में ऑनलाइन क्रिकेट ID और लाइव कैसीनो ID",
      "description": "DaddyAnna247 के साथ तुरंत अपनी ऑनलाइन क्रिकेट बेटिंग ID और लाइव कैसीनो ID पाएं। तेज़ UPI डिपॉज़िट, मिनटों में निकासी और WhatsApp, Telegram व Signal पर 24/7 सहायता।"
    },
    "nav": [
      "एक्सचेंज",
      "गेम्स",
      "कैसे काम करता है",
      "रिव्यू",
      "पेमेंट",
      "सवाल-जवाब"
    ],
    "ticker": [
      "मुंबई में नई ID जारी — 2 मिनट से कम में",
      "₹48,500 की निकासी UPI पर पहुँची — पुणे",
      "IPL मार्केट लाइव, बेहतरीन लिक्विडिटी के साथ",
      "₹1,20,000 का भुगतान पूरा — हैदराबाद",
      "लाइव तीन पत्ती टेबल 24/7 खुली",
      "दिल्ली में नई ID जारी — 2 मिनट से कम में"
    ],
    "header": {
      "login": "लॉगिन",
      "join": "अभी जुड़ें"
    },
    "hero": {
      "eyebrow": "भारत की प्रीमियम बेटिंग ID डेस्क",
      "h1a": "खेलिए",
      "h1gold": "शाही अंदाज़ में।",
      "h1b": "जीतिए चौबीसों घंटे।",
      "sub": "मिनटों में पाएं अपनी खास ऑनलाइन क्रिकेट और कैसीनो ID। तुरंत डिपॉज़िट, तेज़ निकासी और एक पर्सनल मैनेजर — बस एक मैसेज की दूरी पर।",
      "cta": "अपनी ID पाएं",
      "how": "कैसे काम करता है",
      "connect": "जुड़ें",
      "services": [
        "क्रिकेट ID",
        "स्पोर्ट्स एक्सचेंज ID",
        "लाइव कैसीनो ID",
        "तीन पत्ती",
        "अंदर बाहर",
        "एविएटर",
        "घुड़दौड़",
        "कबड्डी",
        "वर्चुअल स्पोर्ट्स"
      ],
      "image": ""
    },
    "exchange": {
      "eyebrow": "लाइव एक्सचेंज",
      "title": "कभी न रुकने वाले मार्केट",
      "sub": "आपके लिए तैयार रेट्स की एक झलक। अपनी ID पाने और खेलने के लिए किसी भी भाव पर टैप करें।",
      "tabs": {
        "cricket": "क्रिकेट",
        "football": "फ़ुटबॉल",
        "tennis": "टेनिस"
      },
      "live": "लाइव",
      "times": {
        "Tomorrow": "कल"
      },
      "note": "दिखाए गए रेट केवल उदाहरण के लिए हैं।"
    },
    "games": {
      "eyebrow": "स्पोर्ट्स और कैसीनो",
      "title": "एक ID. हर गेम.",
      "sub": "IPL की पहली गेंद से लेकर तीन पत्ती के आखिरी पत्ते तक — सब कुछ एक ही अकाउंट में।",
      "play": "अभी खेलें",
      "items": [
        {
          "title": "क्रिकेट एक्सचेंज",
          "desc": "हर गेंद पर बैक और ले करें — IPL, अंतरराष्ट्रीय मैच, T20 लीग और घरेलू टूर्नामेंट।",
          "image": ""
        },
        {
          "title": "लाइव कैसीनो",
          "desc": "तीन पत्ती, अंदर बाहर, रूलेट और बैकारेट — असली डीलरों के साथ।",
          "image": ""
        },
        {
          "title": "फ़ुटबॉल",
          "desc": "दुनिया की टॉप लीग, मैच ऑड्स, गोल और इन-प्ले मार्केट के साथ।",
          "image": ""
        },
        {
          "title": "टेनिस",
          "desc": "ग्रैंड स्लैम से लेकर ATP और WTA टूर तक, हर पॉइंट पर एक्शन।",
          "image": ""
        },
        {
          "title": "एविएटर और क्रैश",
          "desc": "तेज़ मल्टीप्लायर गेम — प्लेन उड़ने से पहले कैश आउट करें।",
          "image": ""
        }
      ]
    },
    "how": {
      "eyebrow": "शुरुआत करें",
      "title": "तीन कदमों में आपकी ID",
      "steps": [
        {
          "title": "हमें मैसेज करें",
          "desc": "WhatsApp, Telegram या Signal पर हमसे संपर्क करें। आपका मैनेजर तुरंत जवाब देगा।",
          "icon": "MessageCircle"
        },
        {
          "title": "पहला डिपॉज़िट करें",
          "desc": "UPI, PhonePe, GPay, Paytm या बैंक ट्रांसफ़र से छोटी राशि जमा करें।",
          "icon": "Wallet"
        },
        {
          "title": "अपनी ID पाएं",
          "desc": "आपका निजी लॉगिन और पासवर्ड तुरंत मिलेगा। लॉगिन करें और खेलना शुरू करें।",
          "icon": "KeyRound"
        }
      ],
      "stats": [
        {
          "value": "5 लाख+",
          "label": "खुश खिलाड़ी"
        },
        {
          "value": "2 मिनट",
          "label": "औसत ID डिलीवरी"
        },
        {
          "value": "24/7",
          "label": "पर्सनल सपोर्ट"
        },
        {
          "value": "100%",
          "label": "गोपनीयता सुरक्षित"
        }
      ]
    },
    "testi": {
      "eyebrow": "खिलाड़ियों की कहानियाँ",
      "title": "सीधे चैट से",
      "sub": "असली बातचीत, असली भुगतान। देखिए भारत भर के खिलाड़ी हमारे मैनेजरों से क्या कहते हैं।",
      "desk": "DaddyAnna247 डेस्क",
      "online": "ऑनलाइन",
      "typing": "टाइप कर रहे हैं…",
      "items": [
        {
          "name": "राहुल एस.",
          "city": "मुंबई",
          "msg": "सच में 2 मिनट में ID मिल गई। मैच खत्म होने से पहले ही ₹25,000 UPI में आ गए!",
          "reply": "धन्यवाद राहुल! पूरे सीज़न हमारे साथ आनंद लीजिए।"
        },
        {
          "name": "प्रिया के.",
          "city": "बेंगलुरु",
          "msg": "लाइव तीन पत्ती टेबल कमाल की हैं। रात 3 बजे भी सपोर्ट ने जवाब दिया — शानदार सर्विस।",
          "reply": "हम हमेशा आपके लिए जागते हैं, प्रिया। खेलते रहिए!"
        },
        {
          "name": "अर्जुन एम.",
          "city": "दिल्ली",
          "msg": "क्रिकेट के सबसे अच्छे रेट यहीं मिले। स्पोर्ट्स और कैसीनो दोनों के लिए एक ही ID — बहुत आसान।",
          "reply": "इसीलिए तो हमने इसे बनाया है, अर्जुन। आज रात के लिए शुभकामनाएँ!"
        },
        {
          "name": "विक्रम आर.",
          "city": "हैदराबाद",
          "msg": "शुरू में थोड़ा डर था, पर हर भुगतान बिना किसी दिक्कत के मिला। दोस्तों को ज़रूर बताऊँगा।",
          "reply": "आपका भरोसा ही हमारी ताकत है, विक्रम। परिवार में स्वागत है!"
        }
      ]
    },
    "pay": {
      "eyebrow": "डिपॉज़िट और निकासी",
      "title": "आपकी रफ़्तार से पैसा",
      "sub": "जिन तरीकों पर आप भरोसा करते हैं, उन्हीं से पैसा जमा करें और निकालें। कोई छिपा चार्ज नहीं, किसी भी समय।",
      "features": [
        {
          "title": "बिजली जैसी निकासी",
          "desc": "दिन या रात, कभी भी निकासी माँगें और मिनटों में अपने बैंक खाते में पाएं।",
          "icon": "Zap"
        },
        {
          "title": "भरोसेमंद और गोपनीय",
          "desc": "आपकी जानकारी पूरी तरह निजी रहती है। हम इसे किसी के साथ साझा नहीं करते।",
          "icon": "ShieldCheck"
        },
        {
          "title": "हमेशा इंसानी सहायता",
          "desc": "चौबीसों घंटे असली अकाउंट मैनेजर — न बॉट, न लंबा इंतज़ार।",
          "icon": "Headphones"
        },
        {
          "title": "सबसे बेहतर ऑड्स",
          "desc": "हर बड़े मार्केट में प्रतिस्पर्धी रेट और ऊँची लिक्विडिटी।",
          "icon": "TrendingUp"
        },
        {
          "title": "ऐप की ज़रूरत नहीं",
          "desc": "सीधे मोबाइल ब्राउज़र से खेलें। हल्का, तेज़ और हमेशा अपडेटेड।",
          "icon": "Smartphone"
        },
        {
          "title": "वेलकम रिवॉर्ड",
          "desc": "पहले डिपॉज़िट पर बोनस और उसके बाद नियमित रीलोड ऑफ़र का आनंद लें।",
          "icon": "Gift"
        }
      ]
    },
    "faq": {
      "eyebrow": "सवाल",
      "title": "जानने योग्य बातें",
      "sub": "अभी भी कोई सवाल? हमारे मैनेजर इस समय ऑनलाइन हैं।",
      "chatOn": "चैट करें",
      "items": [
        {
          "q": "मुझे DaddyAnna247 ID कैसे मिलेगी?",
          "a": "बस हमें WhatsApp, Telegram या Signal पर मैसेज करें। हमारी टीम एक छोटे डिपॉज़िट में आपकी मदद करेगी और लगभग दो मिनट में लॉगिन विवरण भेज देगी।"
        },
        {
          "q": "न्यूनतम डिपॉज़िट कितना है?",
          "a": "आप छोटी राशि से शुरुआत कर सकते हैं। संपर्क करने पर मैनेजर मौजूदा न्यूनतम राशि बता देगा — इसे कम रखा गया है ताकि हर कोई आराम से शुरू कर सके।"
        },
        {
          "q": "निकासी कितनी जल्दी होती है?",
          "a": "ज़्यादातर निकासी कुछ ही मिनटों में, दिन या रात किसी भी समय, सीधे आपके बैंक या UPI खाते में पूरी हो जाती है।"
        },
        {
          "q": "क्या मेरा पैसा और निजी जानकारी सुरक्षित है?",
          "a": "हाँ। हर लेन-देन वेरिफ़ाइड मैनेजर संभालते हैं और आपकी जानकारी पूरी तरह गोपनीय रखी जाती है।"
        },
        {
          "q": "मैं कौन से गेम और स्पोर्ट्स खेल सकता हूँ?",
          "a": "क्रिकेट, फ़ुटबॉल, टेनिस, घुड़दौड़, कबड्डी, साथ ही तीन पत्ती, अंदर बाहर, रूलेट, बैकारेट और एविएटर जैसे लाइव कैसीनो गेम।"
        },
        {
          "q": "क्या एक ही ID से स्पोर्ट्स और कैसीनो दोनों खेल सकते हैं?",
          "a": "बिल्कुल। एक DaddyAnna247 ID से पूरा स्पोर्ट्स एक्सचेंज और पूरी कैसीनो लॉबी खुल जाती है।"
        }
      ]
    },
    "footer": {
      "ctaA": "क्या आप",
      "ctaGold": "तैयार हैं?",
      "ctaSub": "आपकी प्रीमियम ID बस दो मिनट दूर है।",
      "about": "भारत भर में ऑनलाइन स्पोर्ट्स एक्सचेंज और कैसीनो ID के लिए एक प्रीमियम सूचना डेस्क।",
      "rg": "यह वेबसाइट केवल 18 वर्ष या उससे अधिक आयु के वयस्कों के लिए है। बेटिंग में वित्तीय जोखिम होता है और इसकी लत लग सकती है — कृपया ज़िम्मेदारी से खेलें और केवल उतना ही पैसा लगाएँ जितना आप खो सकते हैं। अपनी सीमाएँ तय करें, नियमित ब्रेक लें और ज़रूरत हो तो मदद लें। भाग लेने से पहले अपने राज्य या क्षेत्र के लागू कानूनों की जाँच और पालन करना आपकी ज़िम्मेदारी है।",
      "rights": "सर्वाधिकार सुरक्षित।",
      "explore": "एक्सप्लोर करें",
      "info": "जानकारी",
      "chat": "हमसे चैट करें",
      "follow": "हमें फ़ॉलो करें",
      "disclaimer_title": "प्रतिबंधित क्षेत्र",
      "disclaimer": "हमारी वेबसाइट और सेवाएँ कुछ क्षेत्रों में उपलब्ध नहीं हैं। यदि आप नीचे दिए गए किसी भी क्षेत्र में रहते हैं, तो आपको इस साइट या इसकी सेवाओं का उपयोग करने की अनुमति नहीं है।",
      "territories": [
        "Afghanistan",
        "Algeria",
        "Australia",
        "Bosnia and Herzegovina",
        "Bulgaria",
        "Canada",
        "China (People's Republic Of)",
        "Cuba",
        "Cyprus",
        "Denmark",
        "Ethiopia",
        "France (and French Territories)",
        "Germany",
        "Gibraltar",
        "Iran (Islamic Republic Of)",
        "Iraq",
        "Ireland",
        "Italy",
        "Korea (Democratic People's Republic Of)",
        "Lao (People's Democratic Republic Of)",
        "Macau",
        "Malta",
        "Myanmar",
        "Netherlands",
        "New Zealand",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Romania",
        "Singapore",
        "Slovakia",
        "South Africa",
        "Spain",
        "Sudan",
        "Syrian Arab Republic",
        "Taiwan",
        "Turkey",
        "Uganda",
        "United Kingdom",
        "United States (and U.S. Territories)",
        "Yemen"
      ],
      "adults": "केवल वयस्क",
      "ssl": "SSL सुरक्षित",
      "help": "जुए की समस्या में सहायता",
      "gamble": "BeGambleAware.org",
      "show": "सूची देखें",
      "hide": "सूची छिपाएँ"
    },
    "modal": {
      "a": "अपनी",
      "gold": "ID पाएं",
      "desc": "अपना पसंदीदा ऐप चुनें — मैनेजर तुरंत जवाब देगा।",
      "connect": "जुड़ें"
    },
    "demo": "डेमो ID पाएं",
    "exch": {
      "eyebrow": "हमारे एक्सचेंज",
      "title": "भरोसेमंद एक्सचेंज, एक डेस्क",
      "sub": "अपना पसंदीदा प्लेटफ़ॉर्म चुनें। डेमो ID से मुफ़्त में आज़माएँ, फिर हमारे मैनेजर से मिनटों में असली ID पाएं।",
      "user": "यूज़र ID",
      "pass": "पासवर्ड",
      "visit": "साइट देखें",
      "getId": "असली ID पाएं",
      "copied": "कॉपी हुआ"
    },
    "proofs": {
      "eyebrow": "निकासी प्रमाण",
      "title": "असली भुगतान. हर दिन.",
      "sub": "हमारे खिलाड़ियों को भेजी गई हाल की निकासी की एक झलक। तेज़, पारदर्शी और सीधे बैंक या UPI में।",
      "view": "प्रमाण देखें",
      "close": "बंद करें"
    },
    "promo": {
      "eyebrow": "वेलकम बोनस",
      "title": "पहले डिपॉज़िट पर 10% तक एक्स्ट्रा पाएं",
      "sub": "सिर्फ़ नए खिलाड़ियों के लिए — आज ही ID बनाएं और बड़े वॉलेट से शुरुआत करें।",
      "cta": "बोनस पाएं",
      "terms": "नियम व शर्तें लागू। बोनस की जानकारी आपका अकाउंट मैनेजर देगा।",
      "image": ""
    },
    "winner": {
      "won": "ने अभी जीते",
      "on": "—",
      "just": "वेरिफ़ाइड भुगतान",
      "initials": [
        "अ",
        "क",
        "श",
        "म",
        "र",
        "स",
        "प",
        "व",
        "ग",
        "द",
        "ज",
        "त"
      ],
      "names": [
        "राहुल",
        "अमित",
        "प्रिया",
        "विक्रम",
        "संजय",
        "नेहा",
        "अर्जुन",
        "रोहित",
        "करण",
        "पूजा",
        "दीपक",
        "सुरेश",
        "अंजलि",
        "मनीष",
        "रवि"
      ],
      "cities": [
        "मुंबई",
        "दिल्ली",
        "पुणे",
        "जयपुर",
        "सूरत",
        "लखनऊ",
        "कोलकाता",
        "चेन्नई",
        "हैदराबाद",
        "इंदौर",
        "अहमदाबाद",
        "बेंगलुरु"
      ],
      "games": [
        "क्रिकेट",
        "तीन पत्ती",
        "एविएटर",
        "अंदर बाहर",
        "रूलेट",
        "फ़ुटबॉल"
      ]
    },
    "statsbar": {
      "items": [
        {
          "icon": "Users",
          "prefix": "",
          "value": "500000",
          "suffix": "+",
          "label": "सक्रिय खिलाड़ी"
        },
        {
          "icon": "Percent",
          "prefix": "",
          "value": "98",
          "suffix": "%",
          "label": "भुगतान अनुपात"
        },
        {
          "icon": "Wallet",
          "prefix": "₹",
          "value": "2",
          "suffix": " करोड़+",
          "label": "रोज़ाना भुगतान"
        },
        {
          "icon": "Trophy",
          "prefix": "",
          "value": "10000",
          "suffix": "+",
          "label": "हर महीने इवेंट"
        }
      ]
    },
    "bets": {
      "eyebrow": "क्रिकेट मार्केट",
      "title": "खेल को खेलने का हर तरीका",
      "sub": "टॉस से ट्रॉफी तक — मैच की अपनी समझ के हिसाब से मार्केट चुनें।",
      "items": [
        {
          "icon": "Trophy",
          "title": "मैच विजेता",
          "desc": "जिस टीम पर भरोसा है उस पर लगाएँ — सबसे आसान और लोकप्रिय क्रिकेट मार्केट।",
          "image": ""
        },
        {
          "icon": "Swords",
          "title": "टॉप बल्लेबाज़",
          "desc": "वह खिलाड़ी चुनें जो अपनी टीम के लिए सबसे ज़्यादा रन बनाएगा।",
          "image": ""
        },
        {
          "icon": "Target",
          "title": "टॉप गेंदबाज़",
          "desc": "वह गेंदबाज़ चुनें जो पारी में सबसे ज़्यादा विकेट लेगा।",
          "image": ""
        },
        {
          "icon": "Calculator",
          "title": "कुल रन",
          "desc": "अनुमान लगाएँ कि पारी या सेशन का स्कोर लाइन से ऊपर जाएगा या नीचे रहेगा।",
          "image": ""
        },
        {
          "icon": "CircleSlash",
          "title": "आउट होने का तरीका",
          "desc": "कैच, बोल्ड, LBW, रन आउट या स्टंप — बताइए अगला विकेट कैसे गिरेगा।",
          "image": ""
        },
        {
          "icon": "Medal",
          "title": "मैन ऑफ़ द मैच",
          "desc": "प्रेज़ेंटेशन से पहले ही मैच के सबसे बड़े सितारे को पहचानिए।",
          "image": ""
        },
        {
          "icon": "Layers",
          "title": "सीरीज़ विजेता",
          "desc": "लंबी सोच रखें और पूरी सीरीज़ जीतने वाली टीम पर दाँव लगाएँ।",
          "image": ""
        },
        {
          "icon": "Crown",
          "title": "टूर्नामेंट विजेता",
          "desc": "IPL, वर्ल्ड कप और अन्य लीग का चैंपियन पहले से चुनें।",
          "image": ""
        }
      ]
    },
    "fixtures": {
      "eyebrow": "आने वाले मुकाबले",
      "title": "बड़ी लीग, बड़ा रोमांच",
      "sub": "पहली गेंद से पहले अपनी ID तैयार रखें। मार्केट जल्दी खुलते हैं, बेहतरीन रेट के साथ।",
      "cta": "ID पाएं और खेलें",
      "items": [
        {
          "league": "इंडियन प्रीमियर लीग",
          "teams": "10 टीमें · 74 मैच",
          "date": "मार्च – मई",
          "venue": "पूरे भारत में",
          "image": ""
        },
        {
          "league": "बिग बैश लीग",
          "teams": "8 टीमें · समर T20",
          "date": "दिसंबर – जनवरी",
          "venue": "ऑस्ट्रेलिया",
          "image": ""
        },
        {
          "league": "पाकिस्तान सुपर लीग",
          "teams": "6 टीमें · नाइट T20",
          "date": "फ़रवरी – मार्च",
          "venue": "पाकिस्तान",
          "image": ""
        },
        {
          "league": "ICC वर्ल्ड कप",
          "teams": "शीर्ष देश · वैश्विक खिताब",
          "date": "टूर्नामेंट सीज़न",
          "venue": "दुनिया भर में",
          "image": ""
        }
      ]
    },
    "cities": {
      "eyebrow": "पूरे भारत में सेवा",
      "title": "भारत के हर कोने से",
      "sub": "हर राज्य के खिलाड़ी DaddyAnna247 पर भरोसा करते हैं। आप कहीं भी हों, आपका मैनेजर बस एक मैसेज दूर है।",
      "note": "…और 500+ शहर",
      "map_image": "https://static.prod-images.emergentagent.com/jobs/14353482-e7b8-451f-849a-61062bc4e228/images/2ead184eb0a5605b824deb7b183d22f2193917db4929276d0449a78f98882801.jpeg",
      "items": [
        "मुंबई",
        "दिल्ली",
        "बेंगलुरु",
        "हैदराबाद",
        "चेन्नई",
        "कोलकाता",
        "पुणे",
        "अहमदाबाद",
        "जयपुर",
        "लखनऊ",
        "सूरत",
        "इंदौर",
        "चंडीगढ़",
        "पटना",
        "नागपुर",
        "कोच्चि"
      ]
    },
    "rating": {
      "eyebrow": "खिलाड़ियों की रेटिंग",
      "title": "खिलाड़ियों ने कहा — शानदार",
      "sub": "हज़ारों वेरिफ़ाइड DaddyAnna247 सदस्यों की सच्ची राय।",
      "score": "4.8",
      "total": "12,480 रिव्यू के आधार पर",
      "bars": [
        {
          "stars": "5",
          "pct": "82"
        },
        {
          "stars": "4",
          "pct": "13"
        },
        {
          "stars": "3",
          "pct": "3"
        },
        {
          "stars": "2",
          "pct": "1"
        },
        {
          "stars": "1",
          "pct": "1"
        }
      ],
      "badges": [
        {
          "icon": "BadgeCheck",
          "title": "वेरिफ़ाइड भुगतान"
        },
        {
          "icon": "ShieldCheck",
          "title": "सुरक्षित और निजी"
        },
        {
          "icon": "Clock",
          "title": "24/7 सपोर्ट"
        },
        {
          "icon": "Star",
          "title": "टॉप रेटेड डेस्क"
        }
      ]
    },
    "guides": {
      "eyebrow": "गाइड",
      "title": "संबंधित गाइड और जानकारी",
      "latest": "ब्लॉग से ताज़ा",
      "columns": [
        {
          "heading": "शुरुआत करें",
          "links": [
            {
              "label": "कैसे खेलें",
              "href": "/p/how-to-play"
            },
            {
              "label": "DaddyAnna247 के बारे में",
              "href": "/p/about-us"
            },
            {
              "label": "संपर्क करें",
              "href": "/p/contact-us"
            }
          ]
        },
        {
          "heading": "सुरक्षित खेलें",
          "links": [
            {
              "label": "ज़िम्मेदार गेमिंग",
              "href": "/p/responsible-gambling"
            },
            {
              "label": "सेवा की शर्तें",
              "href": "/p/terms-of-service"
            },
            {
              "label": "गोपनीयता नीति",
              "href": "/p/privacy-policy"
            }
          ]
        },
        {
          "heading": "और देखें",
          "links": [
            {
              "label": "हमारे एक्सचेंज",
              "href": "/#our-exchanges"
            },
            {
              "label": "निकासी प्रमाण",
              "href": "/#withdraw-proof"
            },
            {
              "label": "सभी लेख",
              "href": "/blog"
            }
          ]
        }
      ]
    }
  }
};
